import { styled } from 'styled-system/jsx'

const FieldContainer = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
})

const FieldLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const ChipsRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
})

const Chip = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    paddingX: '14px',
    paddingY: '8px',
    borderRadius: 'pill',
    border: '1.5px solid',
    cursor: 'pointer',
    transition:
      'transform {durations.fast} {easings.appleStandard}, background-color {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}',
    _active: {
      transform: 'scale(0.96)',
    },
  },
  variants: {
    isSelected: {
      true: {
        backgroundColor: 'quickpass.primary',
        borderColor: 'quickpass.primary',
        color: '#FFFFFF',
      },
      false: {
        backgroundColor: '#FFFFFF',
        borderColor: '#E5E0F5',
        color: 'quickpass.ink',
        _hover: {
          borderColor: 'quickpass.primary',
          color: 'quickpass.primary',
        },
      },
    },
  },
})

const HelperText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
})

export { FieldContainer, FieldLabel, ChipsRow, Chip, HelperText }
